module.exports = __webpack_public_path__ + "img/hero-1x.8a6b0b1.png";